<template>
    <b-modal :id="id" ref="negativeStatementListModal" :ok-only="submitSuccess"
             :title="`Declaration of Origin for Article`">
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.negativeStatementListModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="submitProcessing" variant="primary"
                    v-on:click.native="onSubmit">
                {{submitSuccess ? 'OK' : 'SEND'}}
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col v-if="submitSuccess">
                    <p><i class="fas fa-check-circle text-success"></i>We will process your request as quickly as
                        possible.</p>
                </b-col>
                <b-col v-else>
                    <b-form @submit="onSubmit">
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col>
                                <b-form-group label="From: ">

                                <b-form-datepicker
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        locale="en" id="from" name="from" :min="minFrom" :max="maxFrom"
                                        v-model="formData.from" class="mb-2 secondary"></b-form-datepicker>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="To: ">
                                <b-form-datepicker
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        locale="en" id="to" name="to" :disabled="!formData.from" :min="minTo"
                                        :max="maxFrom" v-model="formData.to"
                                        class="mb-2 secondary"></b-form-datepicker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>


        </b-container>
    </b-modal>
</template>
<script>

    import ArticleApi from "@shared/_api/article";

    let now = new Date();


    function initialData() {
        return {
            submitSuccess: false,
            submitProcessing: false,
            submitError: null,
            formData: {
                from: now,
                to: null
            }
        }
    }

    export default {
        name: 'negative-statement-list-modal',
        props: {
            id: String,
            articleList: Array,
            category: Object,
           onSuccess: {
              type: Function,
              default: null
           }
        },
        data() {
            return {
                ...initialData()
            };
        },
        methods: {
            show() {
                this.$refs.negativeStatementListModal.show()
            },
            resetData() {

                this.$validator.reset().finally(() => {
                    Object.assign(this.$data, initialData());
                });
            },
            onSubmit(evt) {
                evt.preventDefault();
                this.submitError = null;
                if (this.submitSuccess) {
                    this.$nextTick(() => {
                        this.$emit('ok');
                        this.$refs.contactModal.hide();
                    })
                } else {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            this.submitProcessing = true;
                            ArticleApi.generateNegativeStatementListPdf(this.articleList, this.category.id, this.formData).then(res => {
                               // Call the onSuccess callback if provided
                               if (this.onSuccess && typeof this.onSuccess === 'function') {
                                  this.onSuccess(res);
                               }

                               this.$refs.negativeStatementListModal.hide();
                            }).catch((e) => {
                               console.log(e);

                                this.submitError = "An error occured. Please contact our customer support.";
                            }).finally(() => {
                                this.submitProcessing = false;
                            });
                        }
                    });
                }
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
        },
        computed: {
            minFrom: function () {
                const minDate = new Date();
                minDate.setYear(minDate.getFullYear() - 1)
                return minDate
            },
            maxFrom: function () {
                const maxDate = new Date();
                maxDate.setYear(maxDate.getFullYear() + 2)
                return maxDate;
            },
            minTo: function () {
                return new Date(this.formData.from);
            }
        },
        watch: {
            'formData.from': function (val) {
                if(val) {
                    let date = new Date(val);
                    this.formData.to = new Date(date.getFullYear() + 1, date.getMonth(), date.getDate());
                }
            }
        }
    }
</script>